// Scroll Management Utilities

export const scrollToTop = (behavior = 'smooth') => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: behavior
  });
};

export const scrollToElement = (elementId, behavior = 'smooth', offset = 0) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: behavior
    });
  }
};

export const getScrollPosition = () => {
  return {
    x: window.pageXOffset || document.documentElement.scrollLeft,
    y: window.pageYOffset || document.documentElement.scrollTop
  };
};

export const setScrollPosition = (x = 0, y = 0, behavior = 'auto') => {
  window.scrollTo({
    top: y,
    left: x,
    behavior: behavior
  });
};

// Hook to manage scroll restoration
export const useScrollToTop = () => {
  const scrollToTopInstant = () => scrollToTop('auto');
  const scrollToTopSmooth = () => scrollToTop('smooth');
  
  return { scrollToTopInstant, scrollToTopSmooth };
};

// Debounced scroll handler
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
